import React, { Component } from 'react';
import _ from 'lodash';
import pkg from '../../package.json';
import { connect } from 'react-redux';

class DebugContainer extends Component {

    constructor(props) {
        super(props);
        this.categoryRefs = [];

        this.state = {
            contentArea: ""
        }

        this._commands = [
            { command: 'c', action: 'displays this.props.content' },
            { command: 'd', action: 'displays this.props.donors' },
            { command: 's', action: 'displays this.props.screen' },
            { command: '\\', action: 'crashes the application (test error)' }
        ]
    }

    viewContent = () => {
        this.setState({
            contentArea: JSON.stringify(this.props.content)
        })
    }

    viewDonors = () => {
        this.setState({
            contentArea: JSON.stringify(this.props.donors)
        })
    }

    viewScreen = () => {
        this.setState({
            contentArea: JSON.stringify(this.props.screen)
        })
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleKeyDown = (event) => {
        switch (event.key) {
            case "c":
                this.viewContent();
                break;
            case "d":
                this.viewDonors();
                break;
            case "s":
                this.viewScreen();
                break;
            case "\\":
                // this.var.doesnt.exist; //crash the app
                break;
            default:
                break;
        }
    }

    renderCommands = () => {
        console.log("render commands");
        return (
            this._commands.map((row, i) => {
                return (
                    <tr key={i}>
                        <td style={{border: '1px solid black'}} >{row.command}</td>
                        <td style={{border: '1px solid black'}} >{row.action}</td>
                    </tr>
                )
            })
        )
    }

    render() {
        console.log("TRYING TO RENDER DEBUG")
        return (
            <div>
                <div>
                    Debug Output <br />
                    Version: {pkg.version} <br />
                    Entry Point: {_.get(this.props, 'content.entry_point', "")}
                </div>

                <table style={{ width: '100%', textAlign: 'left', border: '1px solid black', borderCollapse: 'collapse' }}>
                    <tr>
                        <th style={{border: '1px solid black'}} >Command</th>
                        <th style={{border: '1px solid black'}} >Action</th>
                    </tr>
                    {this.renderCommands()}
                </table>

                <br />
                <hr />
                Debug Content:
                <br />
                <div style={{ backgroundColor: '#E8E8EE', height: 300, width: '100%', overflowY: 'scroll' }}>
                    {this.state.contentArea}
                </div>
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        content: state.content,
        donors: state.donors,
        screen: state.screen
    };
};


export default connect(mapStateToProps, null)(DebugContainer);



// WEBPACK FOOTER //
// ./src/containers/DebugContainer.js